import { useEffect, useMemo } from 'react'
import L from 'leaflet'
import { MapContainer, Marker, TileLayer, Tooltip, useMap } from 'react-leaflet'

function MapController({ selectedShop, shops }) {
  const map = useMap()

  useEffect(() => {
    if (selectedShop) {
      map.flyTo(selectedShop.coordinates, 15, { duration: 0.75 })
      return
    }

    if (shops.length) {
      const bounds = L.latLngBounds(shops.map((shop) => shop.coordinates))
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 13 })
    }
  }, [map, selectedShop, shops])

  return null
}

function makeMarkerIcon(index, selected, favorite) {
  return L.divIcon({
    className: 'vintage-marker-wrap',
    html: `<div class="vintage-marker ${selected ? 'is-selected' : ''} ${favorite ? 'is-favorite' : ''}">
      <span>${String(index + 1).padStart(2, '0')}</span>
    </div>`,
    iconSize: selected ? [48, 48] : [40, 40],
    iconAnchor: selected ? [24, 24] : [20, 20],
  })
}

export default function ShopMap({ shops, selectedShop, favorites, onSelect }) {
  const center = useMemo(() => [35.155, 129.075], [])

  return (
    <MapContainer center={center} zoom={12} scrollWheelZoom className="map">
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {shops.map((shop) => (
        <Marker
          key={shop.id}
          position={shop.coordinates}
          icon={makeMarkerIcon(shop.index, selectedShop?.id === shop.id, favorites.includes(shop.id))}
          eventHandlers={{ click: () => onSelect(shop) }}
          zIndexOffset={selectedShop?.id === shop.id ? 1000 : 0}
        >
          <Tooltip direction="top" offset={[0, -18]} opacity={1}>
            <strong>{shop.name}</strong>
            <small>{shop.region} · {shop.category}</small>
          </Tooltip>
        </Marker>
      ))}
      <MapController selectedShop={selectedShop} shops={shops} />
    </MapContainer>
  )
}
